var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYesBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 57,
    viewBox: "0 0 86 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58724 10.2834C19.1151 3.02814 63.8796 4.38694 74.9989 10.8338C88.5874 18.6593 88.3769 47.8042 74.2853 53.1997C62.2009 57.8167 25.8811 58.987 9.91579 52.3814C-2.55873 47.1843 -0.772262 18.1684 9.58724 10.2883V10.2834Z",
    fill: "#48BF3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58724 5.88443C19.1151 -1.37078 63.8796 -0.0119872 74.9989 6.43489C88.5874 14.2604 87.9303 44.1442 74.2853 48.8008C62.8067 52.7284 25.8811 54.5881 9.91579 47.9825C-2.55873 42.7853 -0.772262 13.7695 9.58724 5.88939V5.88443Z",
    fill: "#73E366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8002 52.8524C29.7364 52.8524 17.4159 51.6276 9.71043 48.4389C5.09537 46.5197 2.00498 41.3572 0.993673 33.9135C-0.705531 21.357 3.86332 9.60383 9.26381 5.49271C14.5 1.50556 29.4489 0.310403 41.7027 0.523646C56.7902 0.78648 69.968 2.93877 75.2607 6.00848C83.4179 10.7048 86.1284 22.6662 85.189 31.796C84.2649 40.7621 80.2557 47.2982 74.4548 49.2769C68.4844 51.3201 55.3066 52.8574 41.8002 52.8574V52.8524ZM38.638 1.48079C26.1019 1.48079 14.2793 2.94871 9.9055 6.27629C4.10459 10.6899 0.562455 23.0282 2.02038 33.7796C2.98036 40.8613 5.85512 45.741 10.116 47.5164C26.2456 54.1914 62.9299 52.1482 74.1108 48.3247C79.5215 46.4799 83.2793 40.2612 84.1622 31.6869C85.0709 22.8646 82.5041 11.3346 74.7319 6.85647C68.9002 3.47434 53.284 1.47086 38.638 1.47086V1.48079Z",
    fill: "#93FF61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3572 12.9117C8.86848 10.6652 14.8183 7.58557 25.2958 6.04824C37.1903 4.28775 53.8384 5.7408 64.2287 7.30788C72.2421 8.51791 74.4444 11.4934 68.3303 10.4966C52.0673 7.84845 36.0404 7.65995 27.9242 10.814C16.8922 15.0987 12.3593 16.0409 10.3521 12.9117H10.3572Z",
    fill: "url(#paint0_linear_713_2641)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9374 8.11613C9.44864 5.75558 21.7589 3.49919 22.6213 4.96709C23.4837 6.43499 12.0206 9.71297 10.9374 8.11613Z",
    fill: "#B0FFB8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.762 5.03636C24.9417 2.93865 32.5085 3.03781 32.3288 4.33711C32.1492 5.6364 24.6439 6.46459 24.762 5.03636Z",
    fill: "#B0FFB8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_713_2641",
    x1: 10.1189,
    y1: 10.0046,
    x2: 71.8263,
    y2: 10.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87F77A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75E568"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesBtn);
export default __webpack_public_path__ + "static/media/yes_btn.6026a1f8de7caff1ed9531aca0920f8d.svg";
export { ForwardRef as ReactComponent };